import { useMemo } from 'react'
import { Box, Flex } from '@chakra-ui/react'
import InlineBanner_1 from '@images/inline_banner_1.webp'
import InlineBanner_2 from '@images/inline_banner_2.webp'
import InlineBanner_3 from '@images/inline_banner_3.webp'
import slimNoImageBanner from '@images/slim_noimage.webp'
import { ScrollableFeatureList, SectionHeader } from '@!/Store/Common/components'
import { buildAssetUrlString } from '@!/Util'
import { Banner } from '@!/components/Banner'

const FeatureListWithBanners = ({ features, tabName, campaign }) => {
  const getNextBanner = useMemo(() => {
    const defaultBanners = [InlineBanner_1, InlineBanner_2, InlineBanner_3]

    const banners = campaign
      ? [
          {
            src: campaign.top_feature_1st_banner_image_url,
            href: campaign.top_feature_1st_banner_url,
          },
          {
            src: campaign.top_feature_2nd_banner_image_url,
            href: campaign.top_feature_2nd_banner_url,
          },
          {
            src: campaign.top_feature_3rd_banner_image_url,
            href: campaign.top_feature_3rd_banner_url,
          },
        ]
      : defaultBanners.map((banner) => ({
          src: buildAssetUrlString(banner),
          href: '/event',
        }))

    return (index) => (index < banners.length ? banners[index] : null)
  }, [campaign])

  // 特集の一番上と特集5つごとにインラインバナーを表示
  // ジャンルタブ選択時は、特集3つ目と、以降は特集5つごとにインラインバナーを表示
  const bannerIndexes = useMemo(() => {
    return tabName === 'home' ? [0, 5, 10] : [3, 8, 13]
  }, [tabName])

  const items = useMemo(() => {
    const featureItems = []
    let bannerIndex = 0

    features.forEach((feature, index) => {
      if (bannerIndexes.includes(index)) {
        const banner = getNextBanner(bannerIndex)
        if (banner) {
          featureItems.push(
            <Box key={`banner-${bannerIndex}`} mx={4}>
              <Banner
                src={banner.src}
                fallbackSrc={buildAssetUrlString(slimNoImageBanner)}
                href={banner.href}
                alt={campaign ? campaign.name : '全作品対象40%ポイント還元'}
                gtmClick={campaign ? `${tabName}バナー${bannerIndex + 1}_${campaign.name}` : `${tabName}バナー${bannerIndex + 1}`}
              />
            </Box>,
          )
          bannerIndex++
        }
      }

      if (index === 0) {
        featureItems.push(<SectionHeader key="section-header" text="オススメコミック特集" />)
      }

      featureItems.push(
        <ScrollableFeatureList key={feature.pathname} title={feature.name} pathname={feature.pathname} books={feature.contents} tabName={tabName} />,
      )
    })

    return featureItems
  }, [features, tabName, campaign, getNextBanner])

  return (
    <Flex direction="column" gap={6}>
      {items}
    </Flex>
  )
}

export default FeatureListWithBanners
